import React from "react";
import { useNavigate } from "react-router-dom";
import "./StoreStatistics.css";
import { FaArrowLeft } from "react-icons/fa";

export default function StoreStatistics() {
  const navigate = useNavigate();

  return (
    <div className="store-simple-page">
      <button className="store-simple-back" onClick={() => navigate(-1)}>
        <FaArrowLeft />
      </button>
      <div className="store-simple-content">
        <h1>Store Statistics</h1>
        <p>
          Here you will be able to see insights about your store performance,
          revenue, and orders.
        </p>
      </div>
    </div>
  );
}


